<template>
  <div class="order-converted">
    <OrderFilter :type.sync="type" @updateFilter="updateFilter" />
    <OrderConvertedDetail
      :type.sync="type"
      :search.sync="search"
    />
  </div>
</template>
<script>
import OrderFilter from '@/components/order/OrderFilter.vue'
import OrderConvertedDetail from '@/components/order/OrderConvertedDetail.vue'
export default {
  name: 'OrderConverted',
  components: {
    OrderFilter,
    OrderConvertedDetail
  },
  data() {
    return {
      type: 'converted',
      search: {
        p: 1,
        limit: 10,
        shop_id: '0',
        time_type: 'create_time',
        begin_time: '',
        end_time: '',
        billing_id: '',
        finance_code: '',
        child_name: '',
        child_id: '',
        type: '',
        kpi_status: '',
        status: '',
        method: ''
      }
    }
  },
  created() {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    this.search.begin_time = year + '-' + date.getMonth() + '-' + day
    this.search.end_time = year + '-' + month + '-' + day
  },
  methods: {
    updateFilter(val) {
      this.search = val
    }
  }
}
</script>
<style lang="scss"></style>
